import { faMinus } from "@jewlr/pro-regular-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-regular-svg-icons/faPlus"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { addAddon, removeAddon } from "areas/cart/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"
import { to_currency } from "helpers/number"

import { QtyBtn } from "./addon"

const UpsellSection = ({
  addon,
  disableActions,
  addExclusiveAddon,
  removeExclusiveAddon,
  selectedAddons,
}) => {
  if (!addon) return null

  const adding =
    disableActions?.id === addon.code && disableActions?.action === "adding"
  const removing =
    disableActions?.id ===
      (selectedAddons[addon.code] && selectedAddons[addon.code].id) &&
    disableActions?.action === "removing"
  const isAdded = !!selectedAddons[addon.code]

  return (
    <div className="bg-grey-4 tablet:w-fit tablet:p-16 flex flex-col items-start gap-10">
      <h2 className="text-16 text-primary leading-20 font-bold">
        Protect the Sparkle with our Essentials Kit
      </h2>
      <div className="border-grey-200 tablet:w-fit flex w-full items-center gap-16 border bg-white p-16">
        <Image
          alt=""
          fallback={addon.images[0]}
          height="1024"
          sizes="108px"
          srcSet={getImgSrcSet(
            addon.images[0].replace(
              sl.config.jewlr_asset_url,
              `${sl.config.jewlr_imgsmbly_url}assets/`
            ),
            1024,
            {
              sizes: [108, 216],
            }
          )}
          style={{ width: "108px" }}
          title={addon.title}
          width="1024"
        />
        <div className="text-14 desktop:gap-12 flex flex-col gap-8">
          <div className="flex flex-col gap-8 font-semibold">
            <h3>{addon.title}</h3>
            <p>{to_currency(addon.price)}</p>
          </div>
          <div className="flex items-center gap-8">
            {!isAdded && !adding ? (
              <Button
                aria-label={`Add ${addon.title} to Cart`}
                className="text-14 leading-14 h-28 w-80 rounded-sm p-0 font-medium"
                disabled={adding}
                loading={adding}
                onClick={() => {
                  if (!adding && !removing) {
                    addExclusiveAddon(addon)
                  }
                }}
                variant="primary"
              >
                <FontAwesomeIcon className="text-12 mr-4" icon={faPlus} />
                Add
              </Button>
            ) : (
              <div
                aria-label={`Added ${
                  selectedAddons[addon.code]
                    ? selectedAddons[addon.code].quantity
                    : 0
                } ${addon.title} to ${jewlr_t("cart")}`}
                className="flex h-28 items-center justify-center"
              >
                <QtyBtn
                  aria-label={`Remove one from ${jewlr_t("cart")}`}
                  className="border-l-grey-20 rounded-bl-md rounded-tl-md border-l"
                  disabled={adding || removing}
                  onClick={() => {
                    if (disableActions.id === "") {
                      removeExclusiveAddon(selectedAddons[addon.code])
                    }
                  }}
                >
                  <FontAwesomeIcon
                    className="text-14 align-text-bottom"
                    icon={removing ? faSpinner : faMinus}
                    spin={removing && disableActions?.action === "removing"}
                  />
                </QtyBtn>
                <div className="border-t-grey-20 border-b-grey-20 leading-14 text-12 flex h-full items-center border-b border-t bg-white px-10 py-6 font-medium tracking-tight">
                  {selectedAddons[addon.code]
                    ? selectedAddons[addon.code].quantity
                    : 0}
                </div>
                <QtyBtn
                  aria-label={`Add one to ${jewlr_t("cart")}`}
                  className="border-r-grey-20 rounded-br-md rounded-tr-md border-r"
                  disabled={adding || removing}
                  onClick={() => {
                    if (disableActions.id === "") {
                      addExclusiveAddon(addon)
                    }
                  }}
                >
                  <FontAwesomeIcon
                    className="text-14 align-text-bottom"
                    icon={adding ? faSpinner : faPlus}
                    spin={adding}
                  />
                </QtyBtn>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
const getSelectedAddons = (addons) => {
  return (addons || [])
    .filter((a) => a.addon_type === "BUNDLE" || a.addon_type === "GIFT_CARD")
    .reduce((acum, addon) => {
      const prev = acum[addon.addon_code]
      return Object.assign(acum, {
        [addon.addon_code]: {
          ...addon,
          id: addon.id || (prev ? prev.id : undefined),
          quantity: prev ? prev.quantity + 1 : 1,
        },
      })
    }, {})
}

const mapStateToProps = (state) => ({
  selectedAddons: getSelectedAddons(state.cart.addons),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  addExclusiveAddon: (addon) => {
    // addAddon from cart_mobile
    dispatch(addAddon(addon, "cart_mobile", ownProps.toggleDisableActions))
  },
  removeExclusiveAddon: (addon) => {
    dispatch(removeAddon(addon, ownProps.toggleDisableActions))
  },
})

UpsellSection.propTypes = {
  addExclusiveAddon: PropTypes.func,
  addon: PropTypes.object,
  disableActions: PropTypes.object,
  removeExclusiveAddon: PropTypes.func,
  selectedAddons: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(UpsellSection)
